import moment from "moment";
import { IDataProvider } from "../../Data/IDataProvider";
import { IGoal, resourceNameGoal } from "../../Entity/IGoal";
import {
    IGoalDataPoint,
    resourceNameGoalDataPoint,
} from "../../Entity/IGoalDataPoint";
import { EGoalDatapointType } from "../../Goals/GoalDataPoints/EGoalDatapointType";
import { IGoalStreakInfo } from "motw_core/DTOs/GoalStreakInfo/IGoalStreakInfo";

const GoalsRepository = () => {
    const GetMatchingGoalAsync = async (
        entry: string,
        dataProvider: IDataProvider
    ) => {
        const goals = await dataProvider.GetRecordsAsync<IGoal>(
            resourceNameGoal
        );

        const entryWords = entry.split(" ");
        const goalName = entryWords[2];

        const matchingGoal = goals.find(
            (goal: IGoal) => goal.name === goalName
        )!;
        return matchingGoal;
    };

    function GetNewWeeklyRateChangeDatapoint(
        goal: Partial<IGoal>,
        value: number
    ) {
        const datapoint: Partial<IGoalDataPoint> = {
            goalid: goal.id,
            value,
            comment: "-",
            egoaldatapointtype: EGoalDatapointType.WeeklyRateChange,
            lastmodifiedtime: moment().format(),
        };

        return datapoint;
    }

    async function AddWeeklyRateChangeDataPointAsync(
        shouldAddWeeklyRateChangeDataPoint: boolean,
        goal: Partial<IGoal>,
        dataProvider: IDataProvider
    ) {
        if (shouldAddWeeklyRateChangeDataPoint) {
            return;
        }

        const value = goal.weeklyrate;

        if (!isNaN(value!)) {
            const datapoint = GetNewWeeklyRateChangeDatapoint(goal, value!);

            await dataProvider.AddRecordAsync(
                resourceNameGoalDataPoint,
                datapoint
            );
        }
    }

    function GetEntryPrefix(
        entrySignificanceIndex: number,
        entrySymbol: string
    ) {
        return Array(entrySignificanceIndex + 3).join(entrySymbol);
    }

    function IsGoalInDanger(goalStreakInfo?: IGoalStreakInfo) {
        if (!goalStreakInfo) {
            return false;
        }

        const latestDatapointTime = goalStreakInfo
            ? goalStreakInfo.result_streakenddate
            : undefined;

        if (!latestDatapointTime) {
            return false;
        }
    }

    return {
        GetMatchingGoalAsync,
        GetNewWeeklyRateChangeDatapoint,
        AddWeeklyRateChangeDataPointAsync,
        IsGoalInDanger,
    };
};

export const goalsRepository = GoalsRepository();
